module.exports = __webpack_public_path__ + "static/media/viuHub.eeb37012.png";